import "./PdfPageSkeleton.scss";

// shown when a PDF page is loading
const PdfPageSkeleton = () => {
  return (
    <div className="pdf-page-skeleton">
      <div className="pdf-page-skeleton__content">
        <div className="pdf-page-skeleton__shimmer" />
      </div>
    </div>
  );
};

export default PdfPageSkeleton;
